export default __webpack_public_path__ + "static/media/telegram.560c94a9.svg";